function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { getMessage } from './get-message';
import MessageContext from './message-context';

var Message = function Message(_ref) {
  var children = _ref.children,
      id = _ref.id,
      locale = _ref.locale,
      onError = _ref.onError,
      params = _ref.params,
      msgParams = _objectWithoutPropertiesLoose(_ref, ["children", "id", "locale", "onError", "params"]);

  return React.createElement(MessageContext.Consumer, null, function (context) {
    var msg = getMessage(context, id, locale);
    if (typeof children === 'function') return children(msg);

    switch (typeof msg) {
      case 'function':
        return msg(Object.assign(msgParams, params));

      case 'boolean':
      case 'number':
      case 'string':
        return String(msg);

      default:
        var res = onError && onError(id, typeof msg);

        if (!res) {
          if (children) return children;
          var pathSep = context.pathSep;
          res = pathSep && Array.isArray(id) ? id.join(pathSep) : String(id);
        }

        return res;
    }
  });
};

Message.displayName = 'Message';
export default Message;